import { createSelector } from './selectorWrapper'
import { CollectionType, isCollectionType } from '../components/collection/collectionTypes'
import { createDataFatal, IFatal } from '../components/error/withFatalCheck'
import { CollectionDetail, TitleIdToCollections } from '../reducers/collections'
import { simpleSelectors } from './basicState'
import { assert } from '../utils/assert'

export type ICollection = {
  header?: string
  collectionType: CollectionType
  totalEpisodeSize?: number
  cardTitleIds: string[]
  refTagPrefix?: string
}

export type ISanitizedCollections = (ICollection | IFatal | null)[]

export const sanitizedCollectionsSelector = createSelector(
  simpleSelectors.pageTitleId,
  simpleSelectors.collections,
  (
    pageTitleID: string,
    titleIdToCollections: TitleIdToCollections
  ): ISanitizedCollections => {
    return sanitizeCollections(titleIdToCollections[pageTitleID])
  }
)

export const sanitizeCollections = (collections: CollectionDetail[] | undefined) => {
  if (!collections) {
    return []
  }

  return collections.map(
    ({ collectionType, titleIds, header, totalCardSize }) => {
      try {
        assert(
          Boolean(collectionType),
          `Empty сollection type: ${collectionType}`
        )

        collectionType = collectionType!.toLowerCase()
        if (!isCollectionType(collectionType)) {
          throw new Error(`Unsupported сollection type: ${collectionType}`)
        }

        const cardTitleIds = titleIds

        if ((cardTitleIds || []).length === 0) {
          return null
        }

        return {
          header,
          collectionType,
          totalEpisodeSize: totalCardSize,
          cardTitleIds
        }
      } catch (e) {
        return createDataFatal('invalid collection', e.message)
      }
    }
  )
}
